//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  computed: {
    cssStyles: function cssStyles() {
      var styles = this.$styles();
      styles["display"] = "grid";
      Utils.type.ifNumber(this.spec.columnGap, function (columnGap) {
        return styles["columnGap"] = "".concat(columnGap, "px");
      });
      Utils.type.ifNumber(this.spec.rowGap, function (rowGap) {
        return styles["rowGap"] = "".concat(rowGap, "px");
      });
      var boxMaxWidth = this.spec.boxMaxWidth ? "".concat(this.spec.boxMaxWidth, "px") : "1fr";
      styles["gridTemplateColumns"] = "repeat(auto-fit, minmax(".concat(this.spec.boxMinWidth, "px, ").concat(boxMaxWidth, "))");
      return styles;
    }
  }
};